import { moment } from '@seiue/moment'
import { DatePicker } from '@seiue/ui'
import { Checkbox, Select } from 'antd'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { AnyType } from 'packages/types'

import { WaringText } from '@/components/Styled'

/**
 * 条件开启
 *
 * @param props - 参数
 * @param props.timedStartAt - 定时开启时间
 * @param props.prevTaskIds - 前序任务
 * @param props.setFormValues - 设置表单值
 * @param props.marginLeft - 左边距
 * @param props.activityTaskOptions - 前序任务选项
 * @param props.setValidCondition - 设置条件是否有效
 * @param props.validCondition - 条件是否有效
 * @param props.openTypeDisabled - 开启方式是否禁用
 * @returns component
 */
export const ConditionSettings: React.FC<{
  timedStartAt?: string | null
  prevTaskIds?: number[] | null
  setFormValues: (fieldName: string, fieldValue: AnyType) => void
  marginLeft?: number
  activityTaskOptions: { value: number; label: string }[]
  setValidCondition: (valid: boolean) => void
  validCondition: boolean
  openTypeDisabled?: boolean
}> = ({
  setFormValues,
  timedStartAt,
  prevTaskIds,
  marginLeft,
  activityTaskOptions,
  setValidCondition,
  validCondition,
  openTypeDisabled,
}) => {
  const [checkedList, setCheckedList] = React.useState<('time' | 'task')[]>([])

  useEffect(() => {
    const getCheckList = () => {
      const list = []
      if (timedStartAt) {
        list.push('time')
      }
      if (prevTaskIds && prevTaskIds.length > 0) {
        list.push('task')
      }
      return list as ('time' | 'task')[]
    }

    setCheckedList(getCheckList())
  }, [])

  return (
    <ConditionWrapper
      style={{ marginLeft }}
      $validCondition={validCondition}
    >
      <Checkbox.Group
        disabled={!!openTypeDisabled}
        options={[
          { label: '定时开启', value: 'time' },
          { label: '前序完成开启', value: 'task' },
        ]}
        value={checkedList}
        onChange={(checkedList) => {
          setCheckedList(checkedList as ('time' | 'task')[])
          if (!checkedList.includes('time')) {
            setFormValues('timedStartAt', null)
          }
          if (!checkedList.includes('task') && prevTaskIds?.length) {
            setFormValues('prevTaskIds', [])
          }
        }}
      />
      {checkedList.length ? (
        <Details>
          {checkedList.includes('time') ? (
            <DatePicker
              disabled={!!openTypeDisabled}
              showTime={true}
              style={{ width: 320 }}
              value={timedStartAt ? moment(timedStartAt) : null}
              onChange={(date) => {
                if (date) {
                  setValidCondition(false)
                }
                setFormValues(
                  'timedStartAt',
                  date?.format('YYYY-MM-DD HH:mm:ss')
                )
              }}
            />
          ) : null}
          {checkedList.includes('task') ? (
            <Select
              disabled={!!openTypeDisabled}
              options={activityTaskOptions}
              value={prevTaskIds}
              style={{ width: 320 }}
              mode="multiple"
              placeholder="请选择"
              onChange={(value) => {
                if (value.length) {
                  setValidCondition(false)
                }
                setFormValues('prevTaskIds', value)
              }}
              status={validCondition ? 'error' : undefined}
              showArrow={true}
              allowClear={true}
            />
          ) : null}
        </Details>
      ) : null}
      {validCondition ? (
        <WaringText>{'请设置定时开启时间或前置条件任务'}</WaringText>
      ) : null}
    </ConditionWrapper>
  )
}

const ConditionWrapper = styled.div<{ $validCondition: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  .ant-picker:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${(props) => props.theme.brand._1} !important;
  }
  margin-bottom: 12px;
  &&& {
    .ant-picker {
      border-color: ${(p) =>
        p.$validCondition ? p.theme.status.danger.element : undefined};
    }
  }
`

const Details = styled.div`
  display: flex;
  gap: 12px;
`
